import { ToastMessage, ToastType } from "./Toast";

class ToastService {
  private static instance: ToastService;
  private messages: ToastMessage[] = [];
  private listeners: ((messages: ToastMessage[]) => void)[] = [];

  private constructor() {}

  public static getInstance(): ToastService {
    if (!ToastService.instance) {
      ToastService.instance = new ToastService();
    }
    return ToastService.instance;
  }

  public subscribe(listener: (messages: ToastMessage[]) => void): () => void {
    this.listeners.push(listener);
    listener(this.messages);

    // 返回取消订阅函数
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  private notify(): void {
    this.listeners.forEach((listener) => listener([...this.messages]));
  }

  public show(type: ToastType, message: string, duration = 2500): string {
    const id = Date.now().toString();
    const createdAt = Date.now(); // 记录创建时间
    this.messages.push({ id, type, message, duration, createdAt });
    this.notify();
    return id;
  }

  public success(message: string, duration = 2500): string {
    return this.show("success", message, duration);
  }

  public error(message: string, duration = 2500): string {
    return this.show("error", message, duration);
  }

  public warning(message: string, duration = 2500): string {
    return this.show("warning", message, duration);
  }

  public info(message: string, duration = 2500): string {
    return this.show("info", message, duration);
  }

  public remove(id: string): void {
    this.messages = this.messages.filter((message) => message.id !== id);
    this.notify();
  }

  public clear(): void {
    this.messages = [];
    this.notify();
  }
}

export default ToastService.getInstance();
